import React, { useState, useEffect } from "react";
import { API_URL } from "../../utils/config";
import "./modificarempresa.css";

function Modificarempresa() {
  const [empreses, setEmpreses] = useState([]);
  const [filteredEmpreses, setFilteredEmpreses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Camp de cerca
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" }); // Configuració d'ordenació
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
  const [empresaDetalls, setEmpresaDetalls] = useState(null); // Per emmagatzemar els detalls de l'empresa
  const [tipusViaOptions, setTipusViaOptions] = useState([]);

  useEffect(() => {
    const fetchEmpreses = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_URL}/Empreses.php`);
        const data = await response.json();
        setEmpreses(data);
        setFilteredEmpreses(data); // Inicialment totes les empreses es mostren
      } catch (error) {
        console.error("Error carregant empreses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEmpreses();
  }, []);

  useEffect(() => {
    async function fetchTipusVia() {
        try {
            const response = await fetch(`${API_URL}/Adreces.php`);
            const data = await response.json();
            if (data.success) {
                setTipusViaOptions(data.data);
            } else {
                console.error("Error carregant TipusVia:", data.message);
            }
        } catch (error) {
            console.error("Error carregant TipusVia:", error);
        }
    }
    fetchTipusVia();
  }, []);



  

  const validateForm = () => {
    const errors = [];

    if (!empresaDetalls.TipusVia.trim()) errors.push("El camp 'Tipus de via' és obligatori.");
    if (!empresaDetalls.NomVia.trim()) errors.push("El camp 'Nom de la via' és obligatori.");
    if (!empresaDetalls.NumVia.trim()) errors.push("El camp 'Número' és obligatori.");
    if (!empresaDetalls.Poblacio.trim()) errors.push("El camp 'Població' és obligatori.");
    if (!empresaDetalls.Pais.trim()) errors.push("El camp 'País' és obligatori.");
    if (!empresaDetalls.CodiPostal.trim()) errors.push("El camp 'Codi postal' és obligatori.");

    if (errors.length > 0) {
      alert(errors.join("\n"));
      return false;
    }

    return true; // Tot correcte
  };


  const handleEmpresaClick = async (empresa) => {
    try {
      setEmpresaSeleccionada(empresa); // Guardem l'empresa seleccionada
  
      // Fem la crida al back-end per obtenir els detalls
      const response = await fetch(`${API_URL}/Detallsempresa.php?idEmpresa=${empresa.IdEmpresa}`);
      const data = await response.json();
  
      if (data.success) {
        setEmpresaDetalls(data.empresa); // Guardem els detalls retornats
      } else {
        console.error("Error obtenint detalls:", data.message);
      }
    } catch (error) {
      console.error("Error carregant els detalls de l'empresa:", error);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    // Filtra les empreses pel camp desitjat
    const filtered = empreses.filter(
      (empresa) =>
        empresa.Nom.toLowerCase().includes(value) ||
        empresa.NomComercial.toLowerCase().includes(value) ||
        empresa.CIF_DNI.toLowerCase().includes(value)
    );
    setFilteredEmpreses(filtered);
  };

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction });

    const sorted = [...filteredEmpreses].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setFilteredEmpreses(sorted);
  };

  const handleSubmit = async () => {
    // Prepara les dades a enviar
    if (!validateForm()) return;
    
    const data = {
      idEntitats: empresaDetalls.idEntitats,
      Entitat: {
        NomComercial: empresaDetalls.NomComercial,
        TelefonFixe: empresaDetalls.TelefonFixe,
        TelefonMobil: empresaDetalls.TelefonMobil,
        TelefonMobil2: empresaDetalls.TelefonMobil2,
        Whatsapp: empresaDetalls.Whatsapp,
        PaginaWeb: empresaDetalls.PaginaWeb,
        Email1: empresaDetalls.Email1,
        Email2: empresaDetalls.Email2,
        CompteBancari: empresaDetalls.CompteBancari,
        Activitat: empresaDetalls.Activitat,
      },
      Adreca: {
        TipusVia: empresaDetalls.TipusVia,
        NomVia: empresaDetalls.NomVia,
        NumVia: empresaDetalls.NumVia,
        EscalaVia: empresaDetalls.EscalaVia,
        Pis: empresaDetalls.Pis,
        Porta: empresaDetalls.Porta,
        Poblacio: empresaDetalls.Poblacio,
        Provincia: empresaDetalls.Provincia,
        Pais: empresaDetalls.Pais,
        CodiPostal: empresaDetalls.CodiPostal,
        Referencies: empresaDetalls.Referencies,
      },
    };
  
    try {
      console.log("Dades enviades:", JSON.stringify(data, null, 2));

      const response = await fetch(`${API_URL}/Modificarempresa.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    
      const text = await response.text(); // Obtenir la resposta com a text
      console.log("Resposta del servidor com a text:", text);
    
      try {
        const result = JSON.parse(text); // Intenta parsejar com JSON
        console.log("Resposta parsejada:", result);
        if (result.success) {
          alert(result.message);
        } else {
          alert(`Error: ${result.message}`);
        }
      } catch (jsonError) {
        console.error("Error parsejant el JSON:", jsonError);
        alert("Resposta no vàlida del servidor. Comprova els logs.");
      }
    } catch (error) {
      console.error("Error en la crida al servidor:", error);
    }
  }

  return (
    <div>
      {!empresaSeleccionada ? (
        <>
          {/* Camp de cerca */}
          <input
            type="text"
            placeholder="Cerca per nom, CIF, etc."
            value={searchTerm}
            onChange={handleSearchChange}
            className="Dashboard-search-bar"
          />
  
          {/* Taula d'empreses */}
          {loading ? (
            <p>Carregant empreses...</p>
          ) : filteredEmpreses.length > 0 ? (
            <table className="Dashboard-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort("Nom")}>Nom</th>
                  <th onClick={() => handleSort("NomComercial")}>Nom Comercial</th>
                  <th onClick={() => handleSort("CIF_DNI")}>CIF</th>
                </tr>
              </thead>
              <tbody>
                {filteredEmpreses.map((empresa, index) => (
                  <tr
                    key={empresa.IdEmpresa}
                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                    onClick={() => handleEmpresaClick(empresa)}
                    style={{ cursor: "pointer" }}
                  >
                    <td>{empresa.Nom}</td>
                    <td>{empresa.NomComercial}</td>
                    <td>{empresa.CIF_DNI}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No s'ha trobat cap empresa.</p>
          )}
        </>
      ) : (
        <div>
          {empresaDetalls ? (
           <form className="Dashboard-form">
             
            
            <div className="Dashboard-form-row">
            <label>
                *Nom de l'empresa: 
                <input 
                  type="text"  
                  value={empresaDetalls.Nom} 
                  className="camp-llarg-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                Nom comercial de l'empresa: 
                <input
                  type="text"
                  value={empresaDetalls.NomComercial}
                  onChange={(e) =>
                    setEmpresaDetalls({ ...empresaDetalls, NomComercial: e.target.value })
                  }
                  className="camp-llarg-input" maxLength="100"
                />
              </label>
              <label>
                *CIF: 
                <input 
                  type="text"  
                  value={empresaDetalls.CIF_DNI} 
                  className="camp-curt-input readonly-input" 
                  readOnly
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                *Tipus de via: 
                <select
                  value={empresaDetalls.TipusVia}
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, TipusVia: e.target.value })}
                >
                  {tipusViaOptions.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                *Nom de la via: 
                <input
                  type="text"
                  value={empresaDetalls.NomVia}
                  className="camp-llarg-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, NomVia: e.target.value })}
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                *Número: 
                <input
                  type="text"
                  value={empresaDetalls.NumVia}
                  className="camp-curt-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, NumVia: e.target.value })}
                />
              </label>
              <label>
                Escala: 
                <input
                  type="text"
                  value={empresaDetalls.EscalaVia}
                  className="camp-curt-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, EscalaVia: e.target.value })}
                />
              </label>
              <label>
                Pis: 
                <input
                  type="text"
                  value={empresaDetalls.Pis}
                  className="camp-curt-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, Pis: e.target.value })}
                />
              </label>
              <label>
                Porta: 
                <input
                  type="text"
                  value={empresaDetalls.Porta}
                  className="camp-curt-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, Porta: e.target.value })}
                />
              </label>
              <label>
                *Població: 
                <input
                  type="text"
                  value={empresaDetalls.Poblacio}
                  className="camp-llarg-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, Poblacio: e.target.value })}
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                *Província: 
                <input
                  type="text"
                  value={empresaDetalls.Provincia}
                  className="camp-llarg-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, Provincia: e.target.value })}
                />
              </label>
              <label>
                *País: 
                <input
                  type="text"
                  value={empresaDetalls.Pais}
                  className="camp-llarg-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, Pais: e.target.value })}
                />
              </label>
              <label>
                *Codi Postal: 
                <input
                  type="text"
                  value={empresaDetalls.CodiPostal}
                  className="camp-curt-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, CodiPostal: e.target.value })}
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                Referències: 
                <textarea
                  value={empresaDetalls.Referencies}
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, Referencies: e.target.value })}
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                Telèfon Fixe: 
                <input
                  type="text"
                  value={empresaDetalls.TelefonFixe}
                  className="camp-curt-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, TelefonFixe: e.target.value })}
                />
              </label>
              <label>
                Mòbil 1: 
                <input
                  type="text"
                  value={empresaDetalls.TelefonMobil}
                  className="camp-curt-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, TelefonMobil: e.target.value })}
                />
              </label>
              <label>
                Mòbil 2: 
                <input
                  type="text"
                  value={empresaDetalls.TelefonMobil2}
                  className="camp-curt-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, TelefonMobil2: e.target.value })}
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                Whatsapp: 
                <input
                  type="text"
                  value={empresaDetalls.Whatsapp}
                  className="camp-curt-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, Whatsapp: e.target.value })}
                />
              </label>
              <label>
                Pàgina web: 
                <input
                  type="text"
                  value={empresaDetalls.PaginaWeb}
                  className="camp-llarg-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, PaginaWeb: e.target.value })}
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                E-mail1: 
                <input
                  type="text"
                  value={empresaDetalls.Email1}
                  className="camp-llarg-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, Email1: e.target.value })}
                />
              </label>
              <label>
                E-mail2: 
                <input
                  type="text"
                  value={empresaDetalls.Email2}
                  className="camp-llarg-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, Email2: e.target.value })}
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                Compte Bancari: 
                <input
                  type="text"
                  value={empresaDetalls.CompteBancari}
                  className="camp-llarg-input"
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, CompteBancari: e.target.value })}
                />
              </label>
              <label className="checkbox-label">
                Activa:
                <input
                  type="checkbox"
                  checked={empresaDetalls.Activitat === 1}
                  onChange={(e) => setEmpresaDetalls({ ...empresaDetalls, Activitat: e.target.checked ? 1 : 0 })}
                />
              </label>
            </div>


          <div className="Dashboard-button-group">
            <button type="button" className="dashboard-btn dashboard-btn-acceptar" onClick={handleSubmit}>
            Modificar
          </button>
  
          <button type="button" className="dashboard-btn dashboard-btn-cancelar" onClick={() => {
                  setEmpresaSeleccionada(null);
                  setEmpresaDetalls(null);
                }}
          >
            Cancel·lar
          </button>
          </div>
        </form>
          ) : (
            <p>Carregant detalls...</p>
          )}
        </div>
      )}
    </div>
  );
  
}

export default Modificarempresa;
